import { Collapse } from 'antd';
import cx from 'classnames';
import {
  FC, ReactElement, useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';

import { ICatalogReducerState } from '../../../redux/reducers/catalogReducer';
import { RootState } from '../../../redux/reducers/rootReducer';
import { CATEGORIES_WITH_NAME_AS_KEY } from '../../../utils/constants/categories-with-name-as-key';
import {
  IFilterSelectsUI,
  IFilterSelectsUIData,
} from '../../../utils/constants/filter-selects';
import { useChangeFilters } from '../../../utils/useChangeFilters';
import ArrowUpIconNew from '../../SVGIcons/ArrowUpIconNew';
import { FilterСategory } from './FilterСategory';
import classes from './VacanciesFilter.module.scss';
import { VacanciesFilterProps } from './VacanciesFilter.types';

const { Panel } = Collapse;

export const VacanciesFilter: FC<VacanciesFilterProps> = ({
  className,
}): ReactElement => {
  const { search } = useLocation();

  const res = useSelector<RootState, ICatalogReducerState['filters'] | []>(
    (state) => state.catalogReducer.filters,
  );

  const [filters, setFilters] = useState<null | IFilterSelectsUI[]>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (res.length > 0) {
      // Получаем параметры из фильтров и строки запроса
      const getParams = res?.map((filter) => ({
        category: filter.category,
        data: searchParams
          .getAll(filter.category)
          .flatMap((data) => data.split(',')),
      }));

      const newFilter = res?.map((item) => {
        const currentParams = getParams?.find(
          (filter) => filter.category === item.category,
        );
        const isNameAsKey = CATEGORIES_WITH_NAME_AS_KEY.includes(item.category);

        // Обновляем данные для каждого фильтра
        const updatedData = item.data.map((itemData) => ({
          ...itemData,
          isSelected:
            currentParams?.data.includes(
              isNameAsKey ? itemData.name : itemData.id,
            ) || false,
        }));

        return {
          ...item,
          data: updatedData,
        };
      });

      setFilters(newFilter as IFilterSelectsUI[]);
    }
  }, [res, search]);

  const { changeFilter } = useChangeFilters({ filters, isCatalog: true });

  const changedFilter = (
    item: IFilterSelectsUIData,
    category: string,
    isSearchItem: boolean,
  ): void => {
    setFilters(changeFilter(item, category, isSearchItem));
  };

  const [activeKeys, setActiveKeys] = useState<string[] | string>([]);

  useEffect(() => {
    setActiveKeys(
      filters?.map((category) => category.categoryTitle as string) || [],
    );
  }, [filters?.length]);

  const renderIcon = ({ isActive }: any) => (
    <ArrowUpIconNew
      className={cx(classes['vacancies-filter__expand-icon'], {
        [classes.up]: !isActive,
      })}
    />
  );

  return (
    <div className={cx(classes['vacancies-filter'], className)}>
      <Collapse
        className={classes['vacancies-filter__list']}
        ghost
        expandIconPosition="end"
        activeKey={activeKeys}
        expandIcon={renderIcon}
        onChange={setActiveKeys}
      >
        {filters?.map(
          (category) => category.data.length > 0 && (
          <Panel
            header={category.categoryTitle}
            key={category.categoryTitle as string}
            className={classes['vacancies-filter__category']}
          >
            <FilterСategory
              category={category.category}
              values={category.data}
              onChangeCheckbox={changedFilter}
            />
          </Panel>
          ),
        )}
      </Collapse>
    </div>
  );
};
